import { useState } from "react";
import { toast } from "sonner";
import { Download, Layers } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const FMT = { pdf: "PDF", xlsx: "Excel", csv: "CSV" };

export const downloadFile = async (url, params, fallback) => {
  const r = await api.get(url, { params, responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || fallback;
  const href = URL.createObjectURL(r.data);
  Object.assign(document.createElement("a"), { href, download: name }).click();
  URL.revokeObjectURL(href);
};

export function CardActions({ tab, days, segment, disabled, exports = true, label = "Crea segmento", testId }) {
  const [busy, setBusy] = useState("");
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");

  const exp = async (fmt) => {
    setBusy(fmt);
    try { await downloadFile("/cards/export", { tab, fmt, days }, `kpi_carte.${fmt}`); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  const create = async () => {
    setBusy("seg");
    try {
      const r = await api.post("/cards/segment", { name, days, ...segment });
      toast.success(`Segmento "${r.data.name}" creato con ${r.data.count.toLocaleString("it-IT")} carte`);
      setOpen(false); setName("");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {exports && Object.keys(FMT).map((f) => <Button key={f} size="sm" variant="outline" data-testid={`cards-export-${tab}-${f}`} disabled={disabled || !!busy} onClick={() => exp(f)}><Download className="mr-1.5 h-3.5 w-3.5" />{busy === f ? "..." : FMT[f]}</Button>)}
      {segment && <Button size="sm" data-testid={testId || `cards-segment-${tab}-button`} className="bg-blue-600 hover:bg-blue-700" disabled={disabled || !!busy} onClick={() => setOpen(true)}><Layers className="mr-1.5 h-3.5 w-3.5" />{label}</Button>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="cards-segment-dialog">
          <DialogHeader><DialogTitle>Crea segmento da questo elenco</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-500">Il segmento conterrà le carte dell'elenco attuale e potrà essere usato nelle Comunicazioni.</p>
          <Input data-testid="cards-segment-name-input" placeholder="Nome segmento" value={name} onChange={(e) => setName(e.target.value)} />
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
            <Button data-testid="cards-segment-confirm" className="bg-blue-600 hover:bg-blue-700" disabled={!name.trim() || busy === "seg"} onClick={create}>{busy === "seg" ? "Creazione..." : "Crea"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
